exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".destinies-container .v-card{width:295px}.destinies-container .v-card.card--destiny-bg{border-radius:15px;border:none}.destinies-container .v-card.card--destiny-bg .v-image{height:295px;width:295px}.destinies-container .v-card.card--destiny-bg .heading-1{font-size:28px;line-height:35px}.destinies-container .v-card.card--destiny-bg .heading-3{font-size:18px;line-height:26px;font-weight:700;font-family:Avenir}@media screen and (max-width:600px){.destinies-container .v-card{width:100%}.destinies-container .v-card.card--destiny-bg .v-image{height:180px;width:180px}}@media screen and (min-width:1440px){.destinies-container .v-card.card--destiny-bg .v-image{height:295px}.destinies-container .v-card.card--destiny-bg .v-btn{font-weight:700}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};